import { render, staticRenderFns } from "./ModificarPasswordCleaner.vue?vue&type=template&id=31631545"
import script from "./ModificarPasswordCleaner.vue?vue&type=script&lang=js"
export * from "./ModificarPasswordCleaner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports